import {
	PanelBody,
	ToggleControl,
	RangeControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

export default function CarouselSettings( { attributes, setAttributes } ) {
	return (
		<PanelBody
			title={ __( 'Carousel', 'brandy-blocks' ) }
			initialOpen={ false }
		>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Infinite loop', 'brandy-blocks' ) }
				checked={ attributes.infiniteLoop ?? true }
				onChange={ ( v ) => setAttributes( { infiniteLoop: v } ) }
			/>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Auto play', 'brandy-blocks' ) }
				checked={ attributes.autoPlay ?? false }
				onChange={ ( v ) => setAttributes( { autoPlay: v } ) }
			/>
			{ attributes.autoPlay && (
				<>
					<RangeControl
						__nextHasNoMarginBottom
						label={ __(
							'Auto play delay (ms)',
							'brandy-blocks'
						) }
						value={ attributes.autoPlayDelay ?? 3000 }
						onChange={ ( v ) =>
							setAttributes( { autoPlayDelay: v } )
						}
						step={ 500 }
						min={ 1000 }
						max={ 20000 }
					/>
					<ToggleControl
						__nextHasNoMarginBottom
						label={ __( 'Pause on hover', 'brandy-blocks' ) }
						checked={ attributes.pauseOnHover ?? true }
						onChange={ ( v ) =>
							setAttributes( { pauseOnHover: v } )
						}
					/>
				</>
			) }
		</PanelBody>
	);
}
